import React from 'react'

const InputRow = ({children}) => (
    <div className="row">
        {children}
    </div>
)

export default InputRow